
import axios from 'axios'
import {callApp, getUserInfo, isApp, isWx, shareFun, getUserNewInfo,} from '@/util/const'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import shareDownload from '../shareDownload'
import {setAuthorization} from '@/axios/userInfo'

export default {
components: {
Flexbox,
FlexboxItem,
Swiper,
SwiperItem,
Grid,
GridItem,
shareDownload
},
data() {
return {
authorization: '',
swiperOption: {
pagination: {
el: '.swiper-pagination',
clickable: true
},
autoplay: {
delay: 2500,
disableOnInteraction: false
},
loop: true
},
list: [{
url: 'opensharevideo://;http://mylink.hk.chinamobile.com/upload/video/mp4/1594975860118973_3/1594975860118973_3.mp4',
img: 'https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/118973.png',
}, {
url: 'opensharevideo://;http://mylink.hk.chinamobile.com/upload/video/mp4/1594975812114068_3/1594975812114068_3.mp4',
img: 'https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/114068.png',
}, {
url: 'opensharevideo://;http://mylink.hk.chinamobile.com/upload/video/mp4/1594975783113845_3/1594975783113845_3.mp4',
img: 'https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/113845.png',
}, {
url: 'opensharevideo://;http://mylink.hk.chinamobile.com/upload/video/mp4/1594972572111872/1594972572111872.mp4',
img: 'https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/111872.png',
}, {
url: 'opensharevideo://;http://mylink.hk.chinamobile.com/upload/video/mp4/1594972528113581/1594972528113581.mp4',
img: 'https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/113581.png',
},
],
total: 0,
totalHK: 0,
status: 1,
end: false,
lang: window.localStorage.getItem('lang')
}
},
methods: {
jumpvideo() {
window.location.href = `openhkhshlogin://cmcchkhsh://utvHome`
},
video(url) {
if (isWx()) {
callApp()
} else {
window.location.href = url
}
},
jumpUrl(index) {
let jumpUrl = ''
switch (index) {
case 1:
jumpUrl = `${this.$t('greenchannel.channel24')}`
window.location.href = jumpUrl
break
case 2:
jumpUrl = 'https://news.qq.com/zt2020/page/feiyan.htm'
window.location.href = jumpUrl
break
case 3:
if (isApp()) {
jumpUrl = `http://mylink.komect.com/activity/poster/#/5G?hideNavigationBar=true&lang=${window.localStorage.getItem('lang')}`
window.location.href = jumpUrl
} else {
callApp()
}
break
case 4:
jumpUrl = `https://www.leavehomesafe.gov.hk/${this.lang}`
window.location.href = jumpUrl
break
case 5:
jumpUrl = `${this.$t('greenchannel.link1')}`
window.location.href = jumpUrl
break
case 6:
jumpUrl = `${location.origin}/roam/#/package?vasId=201581`
window.location.href = jumpUrl
break
case 33:
this.$router.push({ path: '/passing' })
break
case 34:
this.$router.push({ path: '/luckyDraw' })
break
default:
break
}
},
jump(index) {
let jumpUrl = ''
console.log('aad')
if (isApp()) {
switch (index) {
case 5:
if (this.status === 0) {
alert(this.$t('greenchannel.alert'))
} else {
jumpUrl = 'openlogin://openpage://1600'
window.location.href = jumpUrl
}
break
case 6:
if (this.status === 0) {
alert(this.$t('greenchannel.alert'))
} else {
jumpUrl = 'openlogin://openpage://1212'
window.location.href = jumpUrl
}
break
case 7:
if (this.status === 0) {
alert(this.$t('greenchannel.alert'))
} else {
jumpUrl = 'openlogin://openpage://8600'
window.location.href = jumpUrl
}
break
case 8:
if (this.status === 0) {
alert(this.$t('greenchannel.channel19'))
}
jumpUrl = `openlogin://openpage://6010`
window.location.href = jumpUrl
break
default:
break
}
} else {
callApp()
}
}
},
mounted() {},
created() {
this.lang = window.localStorage.getItem('lang')
this.$http.pageInvalidIf().then(res => {
if (res.data.body['404']) {
this.end = true
}
})
delete axios.defaults.headers.common.Authorization
this.$http.getHK(`/v1/api/statistics/proxy/none/nCoV/detail_foreign`).then(res => {
console.log('全国信息：', res)
if (res) {
this.total = res.data.confirm
this.totalHK = res.data.hongkong.children[0].total.confirm
} else {

}
})
this.$http.getHK(`/v1/api/statistics/nCoV/none/proxy?param=2`).then(res => {
console.log('香港信息：', res)
if (res) {
this.totalHK = res.data.results[0].confirmedCount
} else {

}
})
if (this.total === '') {
this.total = 0
}
if (this.totalHK === '') {
this.totalHK = 0
}
if (isApp()) {
getUserInfo({callbackName: 'getUserInfo', needLogin: false})
window.getUserInfo = (obj) => {
if (obj) {
this.authorization = obj.authorization
setAuthorization(obj.authorization)
}
console.log(obj)
}
}
shareFun({
type: 1,
url: `${location.origin}${location.pathname}#/greenchannel`,
title: `${this.$t('greenchannel.sharetitle')}`,
img: `https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/shareLogo/shareLogo`,
content: `${this.$t('greenchannel.sharecontent')}`
})
},
}



// WEBPACK FOOTER //
// ./src/page/greenchannel/index.vue